export { SettingsSidebar as PaymentsSettingsSidebar } from '../SettingsSidebar';
